import React, {Component} from 'react';
import './Privacy.css';

import {getCompanyName, getContactEmailAddress, getCompanyAddress} from "../utils/methods";

class Privacy extends Component {
	componentDidMount() {
		// Scroll to top when component mounts
		window.scrollTo(0, 0);
	}

	render() {
		return (
			<div className="z-privacy-container">
				<div className="z-privacy-content">
					<h1>PRIVACY POLICY - ZWORLD METAVERSE</h1>
					<p className="z-privacy-last-updated">Last Updated: Feb 20, 2025</p>

					<section>
						<h2>INTRODUCTION</h2>
						<p>Welcome to Zworld Metaverse. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our mobile shooting game. Please read this Privacy Policy carefully. By accessing or using Zworld Metaverse, you acknowledge that you have read and understood this Privacy Policy.</p>
					</section>

					<section>
						<h2>INFORMATION WE COLLECT</h2>

						<h3>Personal Information</h3>
						<p>We may collect personal information that you voluntarily provide, including but not limited to:</p>
						<ul>
							<li>Account information (username, email address, password)</li>
							<li>Profile information (display name, avatar)</li>
							<li>Payment information when making in-game purchases</li>
							<li>Communications with us or other players through in-game features</li>
						</ul>

						<h3>Automatically Collected Information</h3>
						<p>When you use Zworld Metaverse, we may automatically collect:</p>
						<ul>
							<li>Device information (model, operating system, unique device identifiers)</li>
							<li>IP address and geolocation data</li>
							<li>Game play statistics and progress</li>
							<li>In-game actions and preferences</li>
							<li>Usage patterns and interaction with game features</li>
						</ul>

						<h3>Information from Third Parties</h3>
						<p>We may receive information about you from third parties, including:</p>
						<ul>
							<li>Information from social media platforms if you connect your account</li>
							<li>Payment processors for transaction verification</li>
							<li>Analytics providers to improve gameplay experience</li>
						</ul>
					</section>

					<section>
						<h2>HOW WE USE YOUR INFORMATION</h2>
						<p>We use the information we collect to:</p>
						<ul>
							<li>Create and maintain your game account</li>
							<li>Provide and improve the game experience</li>
							<li>Process transactions and deliver virtual items</li>
							<li>Respond to your inquiries and provide customer support</li>
							<li>Send updates, security alerts, and administrative messages</li>
							<li>Prevent cheating, fraud, and unauthorized activities</li>
							<li>Personalize your gaming experience</li>
							<li>Analyze usage trends and measure effectiveness of features</li>
							<li>Comply with legal obligations</li>
						</ul>
					</section>

					<section>
						<h2>SHARING YOUR INFORMATION</h2>
						<p>We may share your information with:</p>

						<h3>Service Providers</h3>
						<p>Third-party vendors who assist us in providing the game and related services (e.g., hosting, analytics, customer support, payment processing).</p>

						<h3>Business Partners</h3>
						<p>Strategic partners who work with us to provide the game or related services.</p>

						<h3>Legal Requirements</h3>
						<p>When required by law, such as to comply with a subpoena, legal proceedings, or similar legal process.</p>

						<h3>Business Transfers</h3>
						<p>If we are involved in a merger, acquisition, or sale of all or a portion of our assets.</p>

						<h3>With Your Consent</h3>
						<p>We may share your information in other ways if we have your consent.</p>
					</section>

					<section>
						<h2>DATA RETENTION</h2>
						<p>We retain your personal information for as long as necessary to fulfill the purposes outlined in this Privacy Policy, unless a longer retention period is required for legal, tax, or regulatory purposes.</p>
					</section>

					<section>
						<h2>DATA SECURITY</h2>
						<p>We implement appropriate technical and organizational measures to protect your personal information. However, no method of transmission over the Internet or electronic storage is 100% secure, and we cannot guarantee absolute security.</p>
					</section>

					<section>
						<h2>YOUR CHOICES AND RIGHTS</h2>
						<p>Depending on your location, you may have certain rights regarding your personal information, such as:</p>
						<ul>
							<li>Access to your personal information</li>
							<li>Correction of inaccurate or incomplete information</li>
							<li>Deletion of your personal information</li>
							<li>Restriction or objection to processing</li>
							<li>Data portability</li>
						</ul>
						<p>To exercise these rights, please contact us using the information provided in the "Contact Us" section.</p>
					</section>

					<section>
						<h2>CHILDREN'S PRIVACY</h2>
						<p>Zworld Metaverse is not intended for children under the age of 13 (or higher in jurisdictions where the applicable age is higher). We do not knowingly collect personal information from children. If we discover that a child has provided us with personal information, we will delete such information from our systems.</p>
					</section>

					<section>
						<h2>INTERNATIONAL DATA TRANSFERS</h2>
						<p>Your information may be transferred to and processed in countries other than the country in which you reside. These countries may have data protection laws that differ from your country. We have implemented appropriate safeguards to protect your information when transferred internationally.</p>
					</section>

					<section>
						<h2>CHANGES TO THIS PRIVACY POLICY</h2>
						<p>We may update this Privacy Policy from time to time. The most current version will be posted on our website with the effective date. Your continued use of Zworld Metaverse after any changes indicates your acceptance of the updated Privacy Policy.</p>
					</section>

					<section>
						<h2>THIRD-PARTY LINKS AND SERVICES</h2>
						<p>Zworld Metaverse may contain links to third-party websites, services, or advertisements. These third parties have separate and independent privacy policies. We have no control over and assume no responsibility for the content, privacy policies, or practices of any third-party services.</p>
					</section>

					<section>
						<h2>CONTACT US</h2>
						<p>If you have questions, concerns, or requests regarding this Privacy Policy, please contact us at:</p>
						<p>{getCompanyName()}<br />
							Email: {getContactEmailAddress()}<br />
							Address: {getCompanyAddress()}</p>
					</section>

					<section>
						<h2>JURISDICTION-SPECIFIC PROVISIONS</h2>

						<h3>California Residents</h3>
						<p>Under California Civil Code Section 1798.83, California residents may request information about the disclosure of their personal information to third parties for direct marketing purposes.</p>

						<h3>European Economic Area (EEA) Residents</h3>
						<p>If you are located in the EEA, you have certain rights under the General Data Protection Regulation (GDPR) regarding your personal data.</p>

						<h3>British Columbia Residents</h3>
						<p>Under the Personal Information Protection Act (PIPA), British Columbia residents have rights regarding the collection, use, and disclosure of their personal information.</p>
					</section>

					<p className="z-privacy-consent">By using Zworld Metaverse, you consent to the terms of this Privacy Policy.</p>
				</div>
			</div>
		);
	}
}

export default Privacy;